/**
 * Shared chat formatting helpers (Feb 2026).
 * Used by both CustomerChatBubble and DispatcherChatPanel so their message
 * rendering stays visually consistent (date-day dividers, long-message
 * threshold, ET-timezone-forced time formatting).
 */
import { dayLabelET, formatTimeET } from './timeET';

const LONG_CHAR_THRESHOLD = 240;
const LONG_LINE_THRESHOLD = 4;

export function isLongMessage(body) {
  if (!body) return false;
  if (body.length > LONG_CHAR_THRESHOLD) return true;
  if ((body.match(/\n/g) || []).length + 1 > LONG_LINE_THRESHOLD) return true;
  return false;
}

// Delegate to the shared ET helpers so all timestamps land in Eastern Time
// and naive-UTC strings from MongoDB are parsed correctly.
export const dayLabel = dayLabelET;
export const formatShortTime = formatTimeET;

/**
 * Interleave date-separator markers between messages that fall on different
 * Eastern-Time calendar days. Returns a new array where separators look like
 * `{__sep: true, id, label}` and normal messages pass through unchanged.
 */
export function withDaySeparators(messages) {
  const out = [];
  let lastDay = null;
  for (const m of messages) {
    const label = dayLabelET(m.created_at);
    if (label && label !== lastDay) {
      out.push({ __sep: true, id: `sep-${label}-${m.id || m.created_at}`, label });
      lastDay = label;
    }
    out.push(m);
  }
  return out;
}
